import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruckFast, faSpinner } from "@fortawesome/free-solid-svg-icons";

// This is a simple overlay loading component that can be displayed on top of any screen
export default function OverlayLoading({ isVisible = true, message = "Loading...", icon = "spinner" }) {
  // If not visible, don't render anything
  if (!isVisible) return null;
  
  // Choose the icon based on prop
  const loadingIcon = icon === "truck" ? faTruckFast : faSpinner;
  
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      
      <div className="bg-white rounded-lg px-6 py-4 shadow-lg flex items-center z-10">
        {icon === "truck" ? (
          <div className="mr-3 animate-pulse">
            <FontAwesomeIcon 
              icon={loadingIcon} 
              className="text-blue-600 text-xl" 
            />
          </div>
        ) : (
          <div className="mr-3 animate-spin">
            <FontAwesomeIcon 
              icon={loadingIcon} 
              className="text-blue-600 text-xl" 
            />
          </div>
        )}
        <p className="font-medium text-gray-700">{message}</p>
      </div>
    </div>
  );
}